module.exports = __webpack_public_path__ + "media/images/flags/32/Red-Cross-e200f5cf0abdbabed054f6517a51fbc1.png";